const notifications = {
    addToDesktop: {
        description:
            "İş masanıza ikonamızı əlavə edin:'Paylaş' üzərinə basın və 'Əsas ekrana əlavə et' seçin",
        button: 'Aydındır',
    },
};

export default notifications;
